"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
const i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
const translation_json_1 = __importDefault(require("./locales/en/translation.json"));
const translation_json_2 = __importDefault(require("./locales/es/translation.json"));
i18next_1.default
    .use(i18next_browser_languagedetector_1.default)
    .use(react_i18next_1.initReactI18next)
    .init({
    resources: {
        en: {
            translation: translation_json_1.default,
        },
        es: {
            translation: translation_json_2.default,
        },
    },
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    returnEmptyString: false,
});
exports.default = i18next_1.default;
